'use client';

import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from '../../../forward-ref.js';
import { withStyleProps } from '../../../with-style-props.js';
import type { CommonProps } from '../../types.js';

export interface BoxProps extends CommonProps {
  /** The contents of the box. */
  children: ReactNode;
}

function Box({ children, UNSAFE_className, UNSAFE_style, ...props }: BoxProps, ref: ForwardedRef<HTMLDivElement>) {
  return (
    <div {...props} ref={ref} className={UNSAFE_className} style={UNSAFE_style} role="presentation">
      {children}
    </div>
  );
}

/** A primitive layout component that exposes style props. */
const _Box = withStyleProps(forwardRef(Box), 'Box');

export { _Box as Box };
